import {
  Box,
  createStandaloneToast,
  UseToastOptions,
  Text,
  CloseButton,
  Flex,
} from "@chakra-ui/react";

// Create a standalone toast instance
const { toast } = createStandaloneToast();

// Function to show a toast with dynamic color based on status
const showToast = (
  title: string,
  description: string,
  status: UseToastOptions["status"]
) => {
  // Define background colors for different statuses
  const bgColor = {
    success: "green.500",
    error: "red.500",
    warning: "yellow.500",
    info: "blue.500",
    loading: "gray.500", // Add a color for "loading" status if needed
  }[status || "info"]; // Default to "info" color if no status is provided

  // Call the toast function with custom content, close button, and dynamic background color
  toast({
    position: "bottom-right",
    duration: 4000,
    isClosable: true, // This enables the close button on the toast itself
    render: ({ onClose }) => (
      <Box
        color="white"
        p={2}
        bg={bgColor} // Dynamic background color based on status
        borderRadius="md"
        boxShadow="lg"
        width="300px" // Adjust the width as per your need
      >
        <Flex justifyContent="space-between" alignItems="center">
          <Box mb={0}>
            <Text fontWeight="700" mb={0} fontSize="sm" color="white">
              {title}
            </Text>
            {description && <Text fontSize="xs">{description}</Text>}
          </Box>
          {/* Close Button */}
          <CloseButton size="sm" onClick={onClose} color="black"/>
        </Flex>
      </Box>
    ),
  });
};

export default showToast;
